module.exports = __webpack_public_path__ + "static/img/tab.9743e2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceThree/tab.jpg
// module id = 3uBu
// module chunks = 171